import { Node } from '@tiptap/core';

export const OneLiner = Node.create({
  name: 'oneLiner',
  topNode: true,
  content: 'block',
});
